<div
  *ngIf="colVm.columnType === Types.SectionColumnProductInfoType.TinySpacer"
  class="product-column-general product-spacer"
  [style.visibility]="section?.collapseContent || rowVm?.collapseContent ? 'collapse' : ''"
  [style.text-decoration]="productStylingVm | forcedColumnTextDecoration: colVm : locConfig | async"
  [style.margin-right]="menu | productMenuBasicMethod: 'getSectionBorderMarginSize'"></div>
